import { Form, FormInstance, Upload, message } from 'antd';
import type { UploadChangeParam } from 'antd/es/upload';
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface';
import CloudArrowUpImage from 'assets/images/CloudArrowUp.svg';
import { ImageComponent } from 'presentation/components/ImageComponent';
import { showConfirm } from 'presentation/redux/features/app/appSlice';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import getMessage from 'utilities/constants/MESSAGE';
import { commonHelpers } from 'utilities/helpers';
import { ENV } from '../../../../../infrastructure/config/CONSTANTS';
//fallback
interface props {
    initialImageUrl?: string | undefined;
    form?: FormInstance;
    getBinary?: any;
    existedFile?: any;
    imageId?: number;
}
const STATUS = {
    UPLOADING: 'uploading',
    DONE: 'done',
    UNDER_CONSTRUCTION: '施工中',
};

const UploadImage = ({ getBinary, initialImageUrl, form, existedFile, imageId }: props) => {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState<string>();
    const [initialImg, setInitialImg] = useState<string>();
    const [imageIds, setImageIds] = useState<number>();
    const dispatch = useDispatch();
    const fileTypes = ENV.FILE_TYPE_CU_031_01?.split(',');
    const maxFileSize = Number(ENV.FILE_MAX_SIZE_CU_031_01);

    useEffect(() => {
        if (initialImageUrl) setInitialImg(initialImageUrl);
        if (existedFile && existedFile.file && existedFile.file.originFileObj)
            getBase64(existedFile.file.originFileObj as RcFile, (url) => {
                setImageUrl(url);
            });
    }, []);

    useEffect(() => {
        setInitialImg(initialImageUrl);
        setImageIds(imageId);
    }, [initialImageUrl]);

    const getBase64 = (img: RcFile, callback: (url: string) => void) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result as string));
        reader.readAsDataURL(img);
    };

    const beforeUpload = (file: RcFile) => {
        const invalidFileType = commonHelpers.validateFileTypes(file, fileTypes);
        if (invalidFileType) {
            message.error(getMessage('M007', invalidFileType));
        }
        const isValidFileSize = commonHelpers.validateFileSize(file, maxFileSize);
        if (!isValidFileSize) {
            message.error(getMessage('M006', maxFileSize + 'MB'));
        }
        return !invalidFileType && isValidFileSize;
    };

    const dummyRequest = ({ file, onSuccess }: any) => {
        setTimeout(() => {
            onSuccess('ok');
        }, 0);
    };

    const onChange: UploadProps['onChange'] = (info: UploadChangeParam<UploadFile>) => {
        if (info.file.status === STATUS.UPLOADING) {
            setLoading(true);
            return;
        }
        if (info.file.status === STATUS.DONE) {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj as RcFile, (url) => {
                if (getBinary) getBinary(info.file.originFileObj);
                setLoading(false);
                setImageUrl(url);
                if (form) {
                    form.setFieldValue('isEdit', imageIds);
                }
            });
        }
    };

    const showDeleteConfirm = () => {
        const deleteProps = commonHelpers.getConfirmProps(
            'N0900',
            {
                onOk: () => {
                    removeImage();
                },
            },
            '削除',
        );
        dispatch(showConfirm(deleteProps));
    };

    const removeImage = () => {
        setImageUrl(undefined);
        setInitialImg(undefined);
        if (form) {
            form.resetFields(['image']);
            form.setFieldValue('isEdit', imageIds);
        }
    };

    return (
        <>
            <section
                style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}
                className="label-form"
            >
                <div>間取り図（任意）</div>
            </section>
            <Form.Item name="image" style={{ margin: 0, padding: 0 }}>
                <Upload
                    className="upload-custom button-style"
                    name="avatar"
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={onChange}
                    customRequest={dummyRequest}
                    accept={ENV.FILE_TYPE_CU_031_01}
                >
                    {imageUrl ? (
                        <ImageComponent
                            style={{ width: 343, height: 217.28 }}
                            src={imageUrl}
                            alt="avatar"
                            clickRemove={showDeleteConfirm}
                        />
                    ) : initialImg ? (
                        <ImageComponent
                            style={{ width: 343, height: 217.28 }}
                            src={initialImg}
                            alt="avatar"
                            clickRemove={showDeleteConfirm}
                        />
                    ) : (
                        <section
                            style={{
                                padding: '53px 26px',
                                width: 343,
                                border: '1px solid #D0D3D8',
                                borderRadius: 4,
                                background: '#ffffff',
                            }}
                        >
                            <div className="center-inside" style={{ width: '100%' }}>
                                <img alt="" src={CloudArrowUpImage} style={{ margin: 'auto' }} />
                            </div>
                            <div className="upload-title" style={{ marginTop: 12 }}>
                                間取り図アップロード
                            </div>
                        </section>
                    )}
                </Upload>
            </Form.Item>
        </>
    );
};

export default UploadImage;
